import { FormControl, FormGroup } from '@angular/forms';

import { FormType, FormValueType } from './types';

export const createForm = () => {
  return new FormGroup<FormType>({
    parameter: new FormControl('', { nonNullable: true }),
    source: new FormControl(FormValueType.Value, { nonNullable: true }),
    format: new FormControl(null),
  });
};
